module.exports = __webpack_public_path__ + "img/5@s.c4d5e5c2.jpg";